import { gql } from '../../__generated__/gql'

export const COMMUNITY_PROFILE_POSTS_QUERY = gql(`
  query communityProfilePostsQuery(
    $scope: CommunityPostsScopeEnum!
    $page: Int
    $perPage: Int
    $orderBy: SortProfileCommunityPostsEnum
  ) {
    communityProfilePosts(
      scope: $scope
      page: $page
      perPage: $perPage
      orderBy: $orderBy
    ) {
      ...communityPostFields
      imageUrl
      author {
        id
        firstName
        lastName
        picture
        communityProfile {
          id
          postsCount
          allVotesCount
          online
        }
      }
      lastReply {
        id
        author {
          id
          firstName
          lastName
        }
        createdAt
      }
    }
  }
`)
